import React from "react";
import styles from "./BrandInsights.module.scss";
import Button from "components/core/Button/Button";
import Card from "components/core/Card/Card";
import {
  ContentfulContentType,
  InsightDocument,
} from "@tiicker/util/lib/contentful/types";
import { usePagedContentfulEntries } from "source/contentful/provider";
import { InsightsAssociatedWithBrand } from "@tiicker/util/lib/contentful/queries";
import { getImageReference } from "@tiicker/util/lib/contentful/helpers";
import { EntryCollection } from "contentful";

interface Props {
  tickerSymbol: string;
  onViewMore: () => void;
  loadedInsights: EntryCollection<InsightDocument>;
}

const BrandInsights = (props: Props) => {
  if (props.loadedInsights.items.length === 0) {
    return <></>;
  }

  const insights = props.loadedInsights.items;

  return (
    <div id="Insights" data-scroll-anchor className={styles.Insights}>
      <div className="container">
        <h2 className={styles.Insights__header}>Insights</h2>
        <div className={styles.Insights__cardsContainer}>
          {insights?.map((insight) => {
            const image = getImageReference(
              insight.fields?.heroImage,
              props.loadedInsights.includes
            );

            return image ? (
              <Card
                key={`insight-list-${insight.sys.id}`}
                layout={"column"}
                image={image?.fields?.file?.url}
                title={insight.fields.title}
                badge="Hot Topic"
                url={`/insights/${insight.fields?.slug}`}
              />
            ) : (
              <></>
            );
          })}
        </div>
        <div className={styles.Insights__loadMore}>
          <Button type="secondary" onClick={props.onViewMore}>
            View More
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BrandInsights;
